/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Organizer_Guide_DescriptionInputs */



/**
* | output |
* | --- |
* | "How to create, configure, and run tournaments with Archon." |
*
* @param {Help_Organizer_Guide_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_organizer_guide_description = /** @type {((inputs?: Help_Organizer_Guide_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Organizer_Guide_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Comment créer, configurer et gérer des tournois avec Archon.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cómo crear, configurar y dirigir torneos con Archon.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Como criar, configurar e conduzir torneios com o Archon.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Come creare, configurare e gestire tornei con Archon.")
	return /** @type {LocalizedString} */ ("How to create, configure, and run tournaments with Archon.")
});